module.exports = "<div id='dashboard'>\r\n  Bienvenido\r\n</div>"